// Generated by purs version 0.15.15
import * as Data_Coordinates from "../Data.Coordinates/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Countries from "../Restaumatic.Countries/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Geocoding_Types_AddressExtra from "../Restaumatic.Geocoding.Types.AddressExtra/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var eq2 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Coordinates.eqCoordinates));
var eq3 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Countries.eqCountry);
var eq4 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Geocoding_Types_AddressExtra.eqAddressExtra));
var apartmentNumberIsSymbol = {
    reflectSymbol: function () {
        return "apartmentNumber";
    }
};
var cityIsSymbol = {
    reflectSymbol: function () {
        return "city";
    }
};
var coordinatesIsSymbol = {
    reflectSymbol: function () {
        return "coordinates";
    }
};
var countryIsSymbol = {
    reflectSymbol: function () {
        return "country";
    }
};
var extraIsSymbol = {
    reflectSymbol: function () {
        return "extra";
    }
};
var floorIsSymbol = {
    reflectSymbol: function () {
        return "floor";
    }
};
var formattedAddressIsSymbol = {
    reflectSymbol: function () {
        return "formattedAddress";
    }
};
var postCodeIsSymbol = {
    reflectSymbol: function () {
        return "postCode";
    }
};
var streetIsSymbol = {
    reflectSymbol: function () {
        return "street";
    }
};
var streetNumberIsSymbol = {
    reflectSymbol: function () {
        return "streetNumber";
    }
};
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString);
var DeliveryAddressIsSymbol = {
    reflectSymbol: function () {
        return "DeliveryAddress";
    }
};
var decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1);
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode));
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var decodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode));
var DeliveryAddress = function (x) {
    return x;
};
var toFillFormTypeDeliveryAdd = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeDeliveryAddress_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldDeliveryAddress = function (dictHasField) {
    return dictHasField;
};
var eqDeliveryAddress = {
    eq: function (x) {
        return function (y) {
            return eq(x.apartmentNumber)(y.apartmentNumber) && x.city === y.city && eq2(x.coordinates)(y.coordinates) && eq3(x.country)(y.country) && eq4(x.extra)(y.extra) && eq(x.floor)(y.floor) && eq(x.formattedAddress)(y.formattedAddress) && eq(x.postCode)(y.postCode) && x.street === y.street && x.streetNumber === y.streetNumber;
        };
    }
};
var genericDeliveryAddress = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showDeliveryAddress = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDeliveryAddress)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(apartmentNumberIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(cityIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(coordinatesIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(countryIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(extraIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(floorIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(formattedAddressIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(postCodeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(streetIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(streetNumberIsSymbol)(Data_Show.showString))(Data_Show.showString))(showMaybe))(showMaybe))(showMaybe))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Geocoding_Types_AddressExtra.showAddressExtra)))(Restaumatic_Countries.showCountry))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Coordinates.showCoordinates)))(Data_Show.showString))(showMaybe))))(DeliveryAddressIsSymbol))
};
var unscrambleDecodeDeliveryAddress = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericDeliveryAddress)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(apartmentNumberIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(cityIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(coordinatesIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Data_Coordinates.unscrambleDecodeCoordinates))(/* #__PURE__ */ Unscramble.decodeRecordCons(countryIsSymbol)(Restaumatic_Countries.unscrambleDecodeCountry)(/* #__PURE__ */ Unscramble.decodeRecordCons(extraIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Geocoding_Types_AddressExtra.unscrambleDecodeAddressExtra))(/* #__PURE__ */ Unscramble.decodeRecordCons(floorIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(formattedAddressIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(postCodeIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(streetIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(streetNumberIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))))))))))(Unscramble_Generic.defaultOptions)
};
var encodeDeliveryAddress = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericDeliveryAddress)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(DeliveryAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(streetNumberIsSymbol)(encodeWithOptionsOther))(streetIsSymbol)(encodeWithOptionsOther))(postCodeIsSymbol)(encodeWithOptionsOther1))(formattedAddressIsSymbol)(encodeWithOptionsOther1))(floorIsSymbol)(encodeWithOptionsOther1))(extraIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Geocoding_Types_AddressExtra.encodeAddressExtra))))(countryIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Countries.encodeCountry)))(coordinatesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Data_Coordinates.encodeCoordinates))))(cityIsSymbol)(encodeWithOptionsOther))(apartmentNumberIsSymbol)(encodeWithOptionsOther1)))))
};
var decodeDeliveryAddress = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericDeliveryAddress)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(DeliveryAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(streetNumberIsSymbol)(decodeWithOptionsOther)())(streetIsSymbol)(decodeWithOptionsOther)())(postCodeIsSymbol)(decodeWithOptionsOther1)())(formattedAddressIsSymbol)(decodeWithOptionsOther1)())(floorIsSymbol)(decodeWithOptionsOther1)())(extraIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Geocoding_Types_AddressExtra.decodeAddressExtra)))())(countryIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Countries.decodeCountry))())(coordinatesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Data_Coordinates.decodeCoordinates)))())(cityIsSymbol)(decodeWithOptionsOther)())(apartmentNumberIsSymbol)(decodeWithOptionsOther1)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    DeliveryAddress,
    genericDeliveryAddress,
    eqDeliveryAddress,
    showDeliveryAddress,
    encodeDeliveryAddress,
    decodeDeliveryAddress,
    unscrambleDecodeDeliveryAddress,
    toFillFormTypeDeliveryAdd,
    hasFieldDeliveryAddress,
    newtypeDeliveryAddress_
};
